import { defineComponent } from 'vue';

export const LoginForm = defineComponent({
    props: ['onSubmit'],
    template: require('./login-form.html'),
    methods: {
        validate(values): Promise<object> {
            return new Promise(resolve => {
                // needs to be a promise to avoid conflicting with the $t mixin
                const errors = {} as any;

                if (!values.username) {
                    errors.username = this.$t('auth.login.form.username.error');
                }

                if (!values.password) {
                    errors.password = this.$t('auth.login.form.password.error');
                }

                resolve(errors);
            });
        },
    },
})
